export { default as dates } from './Dates/Dates';
export { default as mobileDec } from './MobileDec/MobileDec';
export { default as storeArq } from './StoreArq/StoreArq';
export { default as validarDoi } from './ValidarDOI/ValidarDOI';